export const TooltipCont = {
  PENCIL: `Click the pencil icon to change the name of your document as it appears in your list of documents. 
This name will not appear in your printed document.`,

  DOCUMENT_NAME: 'My New',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  SKIP: 'Skip',
  FINISH: 'Finish',
  CHANGE_IMAGE: 'Change Image',
  ORDER_PRINTS: 'Order Prints',
  DELETE: 'Delete',
  PREVIEW: 'Preview',
  SAVE_OPTIONS: 'Save Options',
  TO_EDITING: 'Go Back to Editing',
  APPROVE: 'Place Order',
  ARCHIVE: 'Archive',
  BATCH_DOWNLOAD: 'Batch Download',
  CLONE: 'Clone',
  EDIT: 'Edit',
  PUBLISH: 'Publish',
  CLONE_DOCUMENT: 'Clone document',
  CREATE_AGRONOMY_SHEET: 'Create Sustainability or Agronomy Sheet',
  CREATE_BLANK: 'Upload a fullscreen catalog image',
  CREATE_DISCLAIMER: 'Create Disclaimer',
  CREATE_DOCUMENT: 'Create Document',
  CREATE_PRODUCT: 'Create Product',
  CREATE_BRANDING: 'Create Branding',
  CREATE_COVER: 'Create Cover',
  CREATE_COMPLIMENTARY_LOGO: 'Create Complimentary Logo',
  CREATE_COVER_PHOTO: 'Create Cover Photo',
  CREATE_TAGLINE: 'Create Tagline',
  CONVERT_TO_PDF: 'Convert to PDF',
  ZOOM_PLUS: '+',
  ZOOM_MINUS: '-',
  PRODUCT_DIVIDER_DRAG: 'Place on right-hand page only',
  DOWNLOAD_CSV_REPORT: 'Download report as CSV',
};

// All new elements -> “Upload”, “Actions”, page properties button, +/- page in catalog icons and etc. 



// WEBPACK FOOTER //
// ./src/infrastructure/tooltips.ts